import ContactSection from "./ContactSection";
import DoctorProfileBox from "./DoctorProfileBox";
import TabsSectionBox from "./TabsSectionBox";
import VisitsBox from "./VisitsBox";

const DoctorInfoSection = ({ doctor }) => {
  return (
    <div className=" xl:w-3/5 flex flex-col gap-5 overflow-hidden">
      <div
      className="bg-white rounded-[15px] p-5"
      >
        <DoctorProfileBox
      doctor={doctor}
      />
      <VisitsBox
      number={doctor.count}
      />
      </div>
     <div
     className="bg-white rounded-[15px] p-5"
     >
       <TabsSectionBox doctor={doctor}/>
      <ContactSection
      doctor={doctor}
      />
     </div>
    </div>
  );
};

export default DoctorInfoSection;
